import React from 'react'
import PropTypes from 'prop-types'

export default function Translated ({translate, children}) {
  if (children) {
    return React.cloneElement(children, {translated: translate})
  }

  return null
}

Translated.propTypes = {
  children: PropTypes.node,
  translate: PropTypes.string.isRequired,
}
